import React from 'react'
import { CircularProgress, Grid, Typography } from '@mui/material'

const PermissionsUploadLoading = () => {
  return (
    <Grid container alignItems='center' direction='column' spacing={2} style={{ padding: 24 }}>
      <Grid item>
        <Typography variant='subtitle1' noWrap>
          <span style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            Updating permissions...
            <CircularProgress size='1.5rem' />
          </span>
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='body2' color='textSecondary'>
          The update will take place in the background, you are free to navigate through The Ark
        </Typography>
      </Grid>
    </Grid>
  )
}

export default PermissionsUploadLoading
